import React from 'react';
import './Features.css';

const featureData = [
  {
    video: 'https://www.youtube.com/embed/IwgjPQUs8Qg?si=38K9p9ZLEPaUssSY',
    title: 'Enquiry Module',
    description: 'Entry of Leads details and management',
  },
  {
    video: 'https://www.youtube.com/embed/IwgjPQUs8Qg?si=38K9p9ZLEPaUssSY',
    title: 'Enquiry Follow Up',
    description: 'No Missed Follow ups for more conversions',
  },
  {
    video: 'https://www.youtube.com/embed/IwgjPQUs8Qg?si=38K9p9ZLEPaUssSY',
    title: 'Admissions',
    description: 'Admissions conversion directly from Enquiry',
  },
  {
    video: 'https://www.youtube.com/embed/NZ1fAFFE42E?si=D09M_TMmzw-Z-aRM',
    title: 'Fees Managemente',
    description: 'Fees Generation, receipt with installment option',
  },
  {
    video: 'https://www.youtube.com/embed/FCtg3sXHL4Y?si=Wn6658-v0uoed7US',
    title: 'Employee and Users Management',
    description: 'Role based access for employee/users',
  },
  {
    video: 'https://www.youtube.com/embed/C6-tD1OEdpg?si=gfeWqSKigXnFeq1t',
    title: 'Students Attendance',
    description: 'Batch wise Students assignment and attendance',
  },
  // {
  //   video: 'https://www.youtube.com/embed/C6-tD1OEdpg?si=E4H_P7kuGSPeLi-5',
  //   title: 'Employee Attendance',
  //   description: 'Separate panel for employee management for Payroll',
  // },
  {
    video: 'https://www.youtube.com/embed/tDUZ-CvhgiE?si=gCAakc8szgOkNNNa',
    title: 'Course Tracker',
    description: 'Module wise Course tracker for better scheduling',
  },
   {
    video: 'https://www.youtube.com/embed/LjNcbpWmGRA?si=jYrLd_Tc6Azrvs-M" title="YouTube video player',
    title: 'Transportation',
    description: 'Transportation and fleet management',
  },
   {
    video: 'https://www.youtube.com/embed/LjNcbpWmGRA?si=1qrNosbpocGTdnBY',
    title: 'Examination',
    description: 'Manage examinations and grading process',
  },
  {
    video: 'https://www.youtube.com/embed/LjNcbpWmGRA?si=P-2sXanoELuajMy7',
    title: 'Study Material Upload',
    description: 'Option of uploading Course materials for students',
  },
  {
    video: 'https://www.youtube.com/embed/LjNcbpWmGRA?si=alymxvtssuPWroOi',
    title: 'Mass Lead Upload',
    description: 'Admin can upload leads in bulk through excel for time savings',
  },
  {
    video: 'https://www.youtube.com/embed/LjNcbpWmGRA?si=kFXMhYaWwow0V1c5',
    title: 'Report Generate',
    description: 'Various MIS reports exportable in Excel and PDF format',
  },
  
];

const Features = () => {
  return (
    <div id='mainFeature' style={{ backgroundColor: '#f8f9fa', scrollMarginTop:'45px' }}>
      <div className="container py-5">
        <h4 className="fw-bold mb-4 text-center pb-4">MAIN FEATURES</h4>
        <div className="row justify-content-center">
          {featureData.map((feature, index) => (
            <div className="col-md-3 mb-4" key={index}>
              <div className="custom-card rounded-4 p-3 h-100 text-center bg-white">
                <div className="video-wrapper mb-3">
                  <iframe
                    src={feature.video}
                    title={feature.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="video-frame"
                  ></iframe>
                </div>
                <h5 className="fw-semibold mb-2">{feature.title}</h5>
                <p className="text-secondary mb-0">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features;
